export const listRecordTypes = ["candidate", "job", "client", "contact"] as const;
export type ListRecordType = (typeof listRecordTypes)[number];

export const listVisibilities = ["private", "dataset_shared"] as const;
export type ListVisibility = (typeof listVisibilities)[number];

export const listSharingModes = ["private", "dataset", "users"] as const;
export type ListSharingMode = (typeof listSharingModes)[number];

export const listModes = ["static"] as const;
export type ListMode = (typeof listModes)[number];

export const listStatuses = ["active", "archived"] as const;
export type ListStatus = (typeof listStatuses)[number];

export const listTypeStatuses = ["active", "archived"] as const;
export type ListTypeStatus = (typeof listTypeStatuses)[number];

export const listActivityActions = [
  "list.created",
  "list.updated",
  "list.archived",
  "list.renewed",
  "list.member_added",
  "list.member_removed",
  "list.member_moved",
  "list.members_reordered",
  "list.automation_run",
] as const;
export type ListActivityAction = (typeof listActivityActions)[number];

export type ListMemberRef = {
  recordType: ListRecordType;
  recordId: string;
};

/**
 * A list member table is deliberately typed by record type. A column can be
 * configured for a candidate field, for example, without assuming that jobs,
 * clients, or contacts have an equivalent field.
 */
export const listMemberColumnKinds = ["standard", "custom_attribute"] as const;
export type ListMemberColumnKind = (typeof listMemberColumnKinds)[number];

export type ListMemberTableColumn = {
  /** Stable key: `${kind}:${recordType}:${field}`. */
  id: string;
  kind: ListMemberColumnKind;
  recordType: ListRecordType;
  /** Native field name or the dataset custom-attribute ID. */
  field: string;
  label: string;
  visible: boolean;
  /** Pixel width, persisted per list so dense grids retain their layout. */
  width: number;
};

export type ListMemberMoveDestination =
  | { type: "before"; target: ListMemberRef }
  | { type: "after"; target: ListMemberRef }
  | { type: "top" }
  | { type: "bottom" }
  | { type: "position"; position: number };

export function getListMemberKey({ recordType, recordId }: ListMemberRef) {
  return `${recordType}:${recordId}`;
}

export const DEFAULT_LIST_EXPIRY_DAYS = 365;
export const LIST_MEMBER_LIMIT = 10_000;
export const LIST_MEMBER_MUTATION_LIMIT = 1_000;
